module.exports = __webpack_public_path__ + "img/icon-map-implantation-11.9badb74d.svg";